import type { TrialInformationFetchService } from '../application/TrialInformationFetchService';
import { makeContext } from './shared/makeContext';

export const {
  Provider: TrialInformationFetchServiceProvider,
  useContext: useTrialInformationFetchService,
} = makeContext<TrialInformationFetchService.TrialInformationFetchService>(
  'TrialInformationFetchService',
);
